module.exports = __webpack_public_path__ + "img/hero-ecart-api.7fe8ee8e.svg";